export const shouldDisplayOnPage = (
  includedPages: string[] = [],
  excludedPages: string[] = [],
  currentPath: string
): boolean => {
  const includeAllPages = includedPages.length === 0;
  const isCurrentPageIncluded = includedPages.some(pattern => {
    const regex = new RegExp(pattern, 'i');
    return regex.test(currentPath);
  });
  const isIncluded = includeAllPages || isCurrentPageIncluded;

  const isExcluded = excludedPages.some(pattern => {
    const regex = new RegExp(pattern, 'i');
    return regex.test(currentPath);
  });

  return isIncluded && !isExcluded;
};
